import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import ApiService from "../../ApiService";
import H from "history";
import TenantSummary from "../../../models/tenants/TenantSummary";
import {UserAccessLevel, userAccessLevelIsAtLeast} from "../../../models/UserAccessRecord";
import {Link} from "react-router-dom";
import {CommandBarButton} from "office-ui-fabric-react";
import TenantList from "../../tenants/TenantList";

interface ListTenantsPageProps {
    apiService: ApiService;
    history: H.History;
    usersCdbAccessLevel?: UserAccessLevel;
}

interface ListTenantsPageState {
    tenants?: TenantSummary[];
}

class ListTenantsPage extends Component<ListTenantsPageProps & DispatchProps ,ListTenantsPageState> {
    static displayName = ListTenantsPage.name;
    
    constructor(props: ListTenantsPageProps & DispatchProps) {
        super(props);
        
        this.state = {
            tenants: undefined
        }
    }

    async componentDidMount() {
        
        const tenants = await this.props.apiService.getTenantsAdmin();
        
        this.setState({
            tenants
        });
    }

    async componentDidUpdate(prevProps: Readonly<ListTenantsPageProps & DispatchProps>, prevState: ListTenantsPageState): Promise<void> {
    }
    
    render () {
        
        const packageManagementButton = (
            <Link to={`/cdb-admin/tenant-package-management`}>
                <CommandBarButton
                    iconProps={{ iconName: "ZipFolder" }}
                    text="Package management"
                    onClick={() => { }}
                />
            </Link>
        );
        
        return (
            <Fragment>
                <PageTitle title={"All Tenants"}/>
                
                <TenantList title={"All Tenants"} items={this.state.tenants} enableRowLinks={true}>
                    {userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel) ? packageManagementButton : null}
                </TenantList>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History}): ListTenantsPageProps => {
        return {
            history: ownProps.history,
            apiService: state.auth.apiService,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel
        };
    }
)(ListTenantsPage)